var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage"},[_c('ak-model-count-group',{attrs:{"options":_vm.orderoptions}}),_c('ak-model-chart',{staticClass:"m-t-30",attrs:{"title":"用户统计图","options":_vm.peopleOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }